import { render, staticRenderFns } from "./busWitness_list_detail.vue?vue&type=template&id=4280776c"
import script from "./busWitness_list_detail.vue?vue&type=script&lang=js"
export * from "./busWitness_list_detail.vue?vue&type=script&lang=js"
import style0 from "./busWitness_list_detail.vue?vue&type=style&index=0&id=4280776c&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports